import { NgModule } from '@angular/core';

import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { LAZY_FEATURE_MODULE } from 'ish-core/utils/module-loader/module-loader.service';

import { LazyDooFinderSearchComponent } from './lazy-doo-finder-search/lazy-doo-finder-search.component';

@NgModule({
  imports: [FeatureToggleModule],
  providers: [
    {
      provide: LAZY_FEATURE_MODULE,
      useValue: {
        feature: 'dooFinder',
        location: () => import('../store/doo-finder-store.module').then(m => m.DooFinderStoreModule),
      },
      multi: true,
    },
  ],
  declarations: [LazyDooFinderSearchComponent],
  exports: [LazyDooFinderSearchComponent],
})
export class DooFinderExportsModule {}
